export default __webpack_public_path__ + "static/media/spacmaster.65c9c588.png";